<span
    class="core-ui-inline-loading"
    [attr.role]="ringProgress === null ? 'status' : 'progressbar'"
    [attr.aria-valuemin]="ringProgress === null ? null : 0"
    [attr.aria-valuemax]="ringProgress === null ? null : 100"
    [attr.aria-valuenow]="ringProgress"
    [attr.aria-label]="ringProgress === null ? null : (text || 'Progreso')"
    aria-live="polite"
    [ngStyle]="loadingStyle"
>
    <ng-container [ngSwitch]="variant">
        <span
            *ngSwitchCase="'spinner'"
            class="core-ui-inline-loading__spinner"
            [style.width.px]="sizePx"
            [style.height.px]="sizePx"
            aria-hidden="true"
        >
            <span
                *ngFor="let _ of spinnerBlades"
                class="core-ui-inline-loading__spinner-blade"
                [style.width.px]="bladeWidthPx"
                [style.height.px]="bladeHeightPx"
                [style.marginLeft.px]="-bladeWidthPx / 2"
                [style.transformOrigin]="'50% ' + bladeOriginYPx + 'px'"
            ></span>
        </span>

        <span
            *ngSwitchCase="'ring'"
            class="core-ui-inline-loading__ring"
            [class.is-determinate]="ringProgress !== null"
            [style.--ring-progress]="ringProgress + '%'"
            [style.width.px]="sizePx"
            [style.height.px]="sizePx"
            aria-hidden="true"
        ></span>

        <span
            *ngSwitchDefault
            class="core-ui-inline-loading__dots"
            aria-hidden="true"
        >
            <span
                *ngFor="let _ of dots"
                class="core-ui-inline-loading__dot"
                [style.width.px]="dotSizePx"
                [style.minWidth.px]="dotSizePx"
                [style.height.px]="dotSizePx"
                [style.minHeight.px]="dotSizePx"
            ></span>
        </span>
    </ng-container>

    <span *ngIf="text" class="core-ui-inline-loading__text">{{ text }}</span>
</span>
